import { Component, OnInit } from '@angular/core';
import { TrainerMaster } from '../model/TrainerMaster.model';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-trainer-profile',
  templateUrl: './trainer-profile.component.html',
  styleUrls: ['./trainer-profile.component.scss']
})
export class TrainerProfileComponent implements OnInit {

  trainerMaster:TrainerMaster=new TrainerMaster();

  constructor(private authService:AuthService) { }

  

  ngOnInit() {
    this.trainerMaster=this.authService.getTrainerSession();
  }

}
